import UtsavTextField from "src/globalModule/components/UtsavTextField";
import LoadingCircle from "@components/loadings/LoginLoader";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, CircularProgress, Divider, FormControl, InputLabel, MenuItem, Select, Stack, Tooltip, Typography, tooltipClasses, useMediaQuery } from "@mui/material";
import states from "@utils/city&statesData/states";
import axios from "axios";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";
import { updateEventRegistrationAddress } from "src/pujaModule/queries/pujas.queries";
import classes from "../../styles/pujaMainCard.module.css";
import style from "../../styles/pujaRegDetails.module.css";
import NavBar from "./NavBar";
import NavbarBigScreen from "./navbarBigScreen";
// import RegistrationBtn from "./registrationBtn";
const RegistrationStepper = dynamic(() => import("./registrationStepper"), {
  ssr: false
});
// import RegistrationStepper from "./registrationStepper";
import VerificationModal from "./verificationModal";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { trackEvent } from "@utils/analytics/event-analytics";
import { LANGUAGE, WEB_ENGAGE } from "@utils/constants";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { styled } from "@mui/styles";
import AlternateNoVerificationModal from "./alternateNoVerificationModal";
import theme from "src/globalModule/styles/theme";
import CallIcon from "@mui/icons-material/Call";
import whatsappIcon from "../../../../public/assets/newEvent/pujaDetails/whatsapp_icon.webp";
import Image from "next/legacy/image";
import verifiedIcon from "../../../../public/assets/newEvent/pujaDetails/verified_icon.webp";
import editIcon from "../../../../public/assets/newEvent/pujaDetails/edit_text.webp";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import SubmitBtn from "./registrationDetails/submitBtn";
import PujaDetailsCard from "./pujaDetailsCard";
import dynamic from "next/dynamic";
import Navbar from "./registrationDetails/navbar";
/* In this component user will fill his/her gotra, offeringName and address */

const HtmlTooltip = styled(({
  className,
  ...props
}) => <Tooltip {...props} classes={{
  popper: className
}} />)(({
  theme
}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9"
  }
}));
function RegistrationDetails({
  data,
  isLoggedIn = true,
  subEventDetails,
  user,
  registrationDetails
}) {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();
  const {
    eventid,
    subeventid,
    receipt
  } = router.query;
  const bigScreen = useMediaQuery("(min-width:768px)");
  const bigScreenRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [stepNo, setStepNo] = useState(3);
  const [loading, setLoading] = useState(false);
  const [verificationModal, setVerificationModal] = useState(false);
  const [maxOffering, setMaxOffering] = useState(1);
  const [devoteeHeading, setDevoteeHeading] = useState("");
  const [offeringNames, setOfferingNames] = useState([""]);
  const [gotra, setGotra] = useState("");
  const [primaryContact, setPrimaryContact] = useState("");
  const [alternateNumber, setAlternateNumber] = useState(data?.User?.UserDetail?.alternateContact ? data?.User?.UserDetail?.alternateContact.slice(-10) : "");
  const [alterNoVerifyModal, setAlterNoVerifyModal] = useState(false);
  const [alterNoBtn, setAlterNoBtn] = useState(data?.User?.UserDetail?.alternateContact ? false : null);
  const [alterNoAdded, setAlterNoAdded] = useState(data?.User?.UserDetail?.alternateContact ? true : false);
  const [isPrasad, setIsPrasad] = useState(null);
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("West Bengal");
  const [buildingName, setBuildingName] = useState("");
  const [roadName, setRoadName] = useState("");
  const [country, setCountry] = useState("India");
  const [notes, setNotes] = useState("");
  const [prasadAvailability, setPrasadAvailability] = useState(false);
  const [isMainPrasad, setIsMainPrasad] = useState(false);
  // const [mainPrasadAvailable, setMainPrasadAvailable] = useState(false);

  const [linkedBhetEventName, setLinkedBhetEventName] = useState("");
  const [openTooltip, setOpenTooltip] = useState(false);
  const handleClose = () => {
    setOpenTooltip(false);
  };
  const handleOpen = () => {
    setOpenTooltip(cur => !cur);
    //setOpen(true);
  };
  const [textError, setTextError] = useState({
    offeringNameError: false,
    pincodeError: false,
    cityError: false,
    stateError: false,
    buildingNameError: false,
    roadNameError: false,
    optPrasadError: false,
    alternateNoError: false
  });
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  const [prasadOptedWarning, setPrasadOptedWarning] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });

  // const { subEventDetails } = useSelector((state) => state.subEventDetails);
  const isOtpVerified = useSelector(state => state.pujaBooking)?.isOtpVerified;
  // const { state: contextState } = useContext(Store);
  // const loggedInUser = contextState.user;

  useEffect(() => {
    if (user) {
      let buildingName = "";
      let roadName = "";
      if (user.UserAddress?.address) {
        // Split the address at the first comma
        const [name, ...roadParts] = user.UserAddress.address.split(",");
        buildingName = name;
        roadName = roadParts.join(",");
      }

      // Trim extra spaces if needed
      const building = buildingName.trim();
      const road = roadName.trim();
      setOfferingNames(user.offeringName ? user.offeringName.split(",") : [user.name ?? ""]);
      setGotra(user.gotra ?? "");
      if (receipt !== "true") {
        setIsPrasad(user.isPrasad ?? null);
      }
      setPincode(user.UserAddress?.pin ?? "");
      setCity(user.UserAddress?.city ?? "");
      setState(user.UserAddress?.state ?? "West Bengal");
      setBuildingName(building ?? "");
      setRoadName(road ?? "");
      // setCountry(user.address?.country ?? "India");
      setCountry("India");
      setNotes(user.notes ?? "");
    }
  }, [user]);

  // console.log("isPrasad", isPrasad, user);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [stepNo]);
  useEffect(() => {
    if (subEventDetails) {
      setMaxOffering(Number(subEventDetails?.maxOfferingName));
      setPrasadAvailability(subEventDetails?.isPrasad || data?.linkedBhetPrasadAvailability?.length > 0);
      if (router.locale === LANGUAGE.ENGLISH) {
        setDevoteeHeading(subEventDetails.devoteeHeading ? "Enter " + subEventDetails.devoteeHeading + " Details" : "Enter Devotee Details");
      } else if (router.locale === LANGUAGE.HINDI) {
        setDevoteeHeading(subEventDetails.devoteeHeading ? subEventDetails.devoteeHeading + " का विवरण दर्ज करें" : "भक्त का विवरण दर्ज करें");
      }
      if (!subEventDetails?.isPrasad) {
        setIsPrasad(false);
      }
    }
  }, [subEventDetails]);
  useEffect(() => {
    // console.log("registrationDetails", registrationDetails);
    if (registrationDetails?.linkedBhetPrasadAvailability.length > 0) {
      setLinkedBhetEventName(registrationDetails.linkedBhetPrasadAvailability.map(item => item.name));
    }
    setPrimaryContact(registrationDetails?.contact?.slice(-10));
    setIsMainPrasad(registrationDetails?.isMainPrasad);
    setIsPrasad(registrationDetails?.isMainPrasad);
  }, [registrationDetails]);
  useEffect(() => {
    if (stepNo === 3) {
      trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_DETAILS_CARD + " " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_DETAILS_CARD,
        [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(subEventDetails?.eventRegistrationAmount),
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subeventid
      });
    } else if (stepNo === 4) {
      trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_WISH_CARD + " " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_WISH_CARD,
        [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(subEventDetails?.eventRegistrationAmount),
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subeventid
      });
    }
  }, [stepNo]);
  useEffect(() => {
    if ((!isLoggedIn || receipt === "true") && !isOtpVerified) {
      setVerificationModal(true);
    } else {
      setVerificationModal(false);
    }
  }, [isLoggedIn]);
  useEffect(() => {
    if (bigScreenRef.current && isPrasad) {
      const scrollOptions = {
        behavior: "smooth",
        top: bigScreenRef.current.scrollHeight
      };
      bigScreenRef.current.scrollIntoView(scrollOptions);
    }
  }, [bigScreenRef.current, isPrasad]);
  const trackEventFunction = () => {
    if (stepNo === 3) {
      trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_DETAILS_CARD + " " + WEB_ENGAGE.BUTTON_NAMES.POSITIVE + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_DETAILS_CARD,
        [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(subEventDetails?.eventRegistrationAmount),
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subeventid
      });
    } else if (stepNo === 4) {
      trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_WISH_CARD + " " + WEB_ENGAGE.BUTTON_NAMES.POSITIVE + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_WISH_CARD,
        [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(subEventDetails?.eventRegistrationAmount),
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subeventid,
        [WEB_ENGAGE.EVENT_PROPERTIES.OFFERING_NAME_COUNT]: offeringNames.length,
        [WEB_ENGAGE.EVENT_PROPERTIES.IS_ADDRESS_GIVEN]: isPrasad
      });
    }
  };
  const addOfferingName = () => {
    const isLastOfferingNameEmpty = offeringNames.slice(-1)[0].trim() === "";
    if (isLastOfferingNameEmpty) {
      setErrorModal({
        open: true,
        heading: `${t("puja-registration")}`,
        message: `${t("please-enter-devotee-name")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return;
    }
    if (offeringNames.length >= maxOffering) {
      return;
    }
    setOfferingNames([...offeringNames, ""]);
  };
  const deleteOfferingName = index => {
    const updatedOfferingNames = [...offeringNames];
    updatedOfferingNames.splice(index, 1);
    setOfferingNames(updatedOfferingNames);
  };
  const handleChangeOfferingName = (e, index) => {
    let value = e.target.value;
    // console.log("value", value);
    const regex = /^$|^[a-zA-Z ]+(([, ][a-zA-Z ])?[a-zA-Z ]*)*$/;
    if (!regex.test(value)) {
      return;
    }
    if (e.target.validity.valid) {
      setTextError(prev => {
        return {
          ...prev,
          offeringNameError: false
        };
      });
    }
    const offeringName = value.split(",");
    const updatedOfferingNames = [...offeringNames];
    updatedOfferingNames[index] = offeringName[0];
    setOfferingNames(updatedOfferingNames);
  };
  const handleGotra = e => {
    let value = e.target.value;
    const regex = /[`~!@#$%^&*()_|+\-=?;:'".<>\{\}\[\]\\\/0-9]/gi;
    if (regex.test(value)) {
      return;
    }
    let gotra = value.split(",");
    setGotra(gotra[0]);
  };

  // const handlePrasad = () => {
  //   setIsPrasad(!isPrasad);
  // };

  const getLocation = () => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_DETAILS_CARD + " " + WEB_ENGAGE.ITEM_NAMES.LOCATION + " " + WEB_ENGAGE.EVENT_NAMES.ITEM_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_DETAILS_CARD,
      [WEB_ENGAGE.EVENT_PROPERTIES.ITEM_NAME]: WEB_ENGAGE.ITEM_NAMES.LOCATION,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(subEventDetails?.eventRegistrationAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subeventid
    });
    if (!navigator.geolocation) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
      navigator.geolocation.getCurrentPosition(position => {
        getAddress(position.coords.latitude, position.coords.longitude, process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY);
      }, () => {
        setIsLoading(false);
      });
    }
  };
  const getAddress = (lat, long, googleKey) => {
    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${googleKey}`).then(res => res.json()).then(address => setZip(address));
  };
  const setZip = address => {
    let full_address = "";
    const addressArray = address.results[1].address_components;
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0] === "postal_code") {
        setPincode(addressArray[i].long_name);
        continue;
      }
      if (addressArray[i].types[0] === "administrative_area_level_1") {
        setState(addressArray[i].long_name);
        continue;
      }
      if (addressArray[i].types[0] === "locality") {
        setCity(addressArray[i].long_name);
        continue;
      }
      if (addressArray[i].types[0] === "country") {
        setCountry(addressArray[i].long_name);
        continue;
      }
      full_address = full_address + addressArray[i].long_name + ", ";
    }
    full_address = full_address.replace(/,\s*$/, "");
    setRoadName(full_address);
    setBuildingName("");
    setIsLoading(false);
  };
  const pincodeCheck = async pincode => {
    setIsLoading(true);
    try {
      const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}`);
      if (response.data.status === "OK") {
        const data = response.data.results;
        if (data.length > 0) {
          const components = data[0].address_components;
          for (const item of components) {
            if (item.types[0] === "administrative_area_level_1") {
              setState(item.long_name);
            }
            if (item.types[0] === "locality") {
              setCity(item.long_name);
            }
            if (item.types[0] === "country") {
              setCountry(item.long_name);
            }
          }
          setBuildingName("");
          setRoadName("");
        }
      } else {
        setErrorModal({
          open: true,
          heading: `${t("wrong-pincode")}`,
          message: `${t("please-recheck-the-pincode-you-have-entered")}`,
          acceptMethod: () => setErrorModal({
            ...errorModal,
            open: false
          }),
          icon: <ErrorOutlineOutlinedIcon sx={{
            fontSize: "3rem",
            color: "red"
          }} />
        });
        setPincode("");
        setCity("");
        setState("");
        setBuildingName("");
        setRoadName("");
        setCountry("");
      }
      setIsLoading(false);
    } catch (error) {
      setErrorModal({
        open: true,
        heading: `${t("something-went-wrong")}`,
        message: error.message,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      setCity("");
      setState("");
      setBuildingName("");
      setRoadName("");
      setCountry("");
      setIsLoading(false);
    }
  };
  const handlePincode = e => {
    let pincode = e.target.value;
    if (pincode.length > 6) {
      return;
    }
    if (pincode.length === 6) {
      pincodeCheck(pincode);
    }
    setPincode(pincode);
    if (e.target.validity.valid) {
      setTextError(prev => {
        return {
          ...prev,
          pincodeError: false
        };
      });
    }
  };
  const handleCityChange = e => {
    let value = e.target.value;
    const sanitizedValue = value.replace(/[.,#!$%^&*;:{}=\_`~()]/g, "");
    setCity(sanitizedValue);
    if (e.target.validity.valid) {
      setTextError(prev => {
        return {
          ...prev,
          cityError: false
        };
      });
    }
  };
  const handleStateChange = value => {
    setState(value);
    if (value) {
      setTextError(prev => {
        return {
          ...prev,
          stateError: false
        };
      });
    }
  };
  const handleBuildingName = e => {
    let value = e.target.value;
    const sanitizedValue = value.replace(/[.,#!$%^&*;:{}=\_`~()]/g, "");
    setBuildingName(sanitizedValue);
    if (e.target.validity.valid) {
      setTextError(prev => {
        return {
          ...prev,
          buildingNameError: false
        };
      });
    }
  };
  const handleRoadName = e => {
    let value = e.target.value;
    setRoadName(value);
    if (e.target.validity.valid) {
      setTextError(prev => {
        return {
          ...prev,
          roadNameError: false
        };
      });
    }
  };
  const handleNotes = e => {
    let value = e.target.value;
    if (value.length > 300) {
      setNotes(value.slice(0, 300));
      return;
    }
    setNotes(value);
  };
  const changeStep = e => {
    e.preventDefault();
    setLoading(true);
    if (alterNoBtn === null) {
      setTextError(prev => {
        return {
          ...prev,
          alternateNoError: true
        };
      });
      setLoading(false);
      return;
    }
    if (isPrasad === null) {
      setTextError(prev => {
        return {
          ...prev,
          optPrasadError: true
        };
      });
      setLoading(false);
      return;
    }

    // if (isPrasad === null) {
    //   setErrorModal({
    //     open: true,
    //     heading: `${t("puja-registration")}`,
    //     message: `${t("please-fill-all-the-fields")}`,
    //     acceptMethod: () => setErrorModal({ ...errorModal, open: false }),
    //     icon: (
    //       <ErrorOutlineOutlinedIcon sx={{ fontSize: "3rem", color: "red" }} />
    //     ),
    //   });
    //   setLoading(false);
    //   return;
    // }

    if (!e.target.checkValidity()) {
      const formElements = e.target.elements;
      let invalidField = null;
      for (let i = 0; i < formElements.length; i++) {
        if (!formElements[i].validity.valid) {
          invalidField = formElements[i].name;
          if (invalidField === "Offering Name") {
            setTextError(prev => {
              return {
                ...prev,
                offeringNameError: true
              };
            });
          } else if (invalidField === "Pincode") {
            setTextError(prev => {
              return {
                ...prev,
                pincodeError: true
              };
            });
          } else if (invalidField === "City") {
            setTextError(prev => {
              return {
                ...prev,
                cityError: true
              };
            });
          } else if (invalidField === "State") {
            setTextError(prev => {
              return {
                ...prev,
                stateError: true
              };
            });
          } else if (invalidField === "Floor/House No./Building Name") {
            setTextError(prev => {
              return {
                ...prev,
                buildingNameError: true
              };
            });
          } else if (invalidField === "Road Name") {
            setTextError(prev => {
              return {
                ...prev,
                roadNameError: true
              };
            });
          }
          setLoading(false);
          break;
        }
      }
      return;
    }
    if (isPrasad) {
      if (pincode === "" || city === "" || state === "" || buildingName === "" || roadName === "") {
        setErrorModal({
          open: true,
          heading: `${t("puja-registration")}`,
          message: `${t("please-fill-all-the-fields")}`,
          acceptMethod: () => setErrorModal({
            ...errorModal,
            open: false
          }),
          icon: <ErrorOutlineOutlinedIcon sx={{
            fontSize: "3rem",
            color: "red"
          }} />
        });
        return;
      } else {
        setStepNo(4);
      }
    } else {
      setStepNo(4);
    }
    setLoading(false);
  };
  const updateAddress = async e => {
    e.preventDefault();
    setLoading(true);
    if (!e.target.checkValidity()) {
      const formElements = e.target.elements;
      let invalidField = null;
      for (let i = 0; i < formElements.length; i++) {
        if (!formElements[i].validity.valid) {
          invalidField = formElements[i].name;
          if (invalidField === "Offering Name") {
            setTextError(prev => {
              return {
                ...prev,
                offeringNameError: true
              };
            });
          } else if (invalidField === "Pincode") {
            setTextError(prev => {
              return {
                ...prev,
                pincodeError: true
              };
            });
          } else if (invalidField === "City") {
            setTextError(prev => {
              return {
                ...prev,
                cityError: true
              };
            });
          } else if (invalidField === "State") {
            setTextError(prev => {
              return {
                ...prev,
                stateError: true
              };
            });
          } else if (invalidField === "Floor/House No./Building Name") {
            setTextError(prev => {
              return {
                ...prev,
                buildingNameError: true
              };
            });
          } else if (invalidField === "Road Name") {
            setTextError(prev => {
              return {
                ...prev,
                roadNameError: true
              };
            });
          }
          break;
        }
      }
      return;
    }
    let fAlternateNumber = alternateNumber !== "" ? "+91" + alternateNumber : null;
    const res = await updateEventRegistrationAddress({
      data: {
        address: isPrasad ? buildingName + ", " + roadName : null,
        country: isPrasad ? country : null,
        state: isPrasad ? state : null,
        city: isPrasad ? city : null,
        pin: isPrasad ? pincode : null,
        registrationID: registrationDetails?.registrationID,
        uid: registrationDetails?.uid,
        gotra: gotra,
        offeringName: offeringNames.join(","),
        notes: notes,
        isPrasad: isPrasad,
        alternateContact: fAlternateNumber !== primaryContact ? fAlternateNumber : null
      }
    });
    if (res && res.err) {
      setErrorModal({
        open: true,
        heading: `${t("something-went-wrong")}`,
        message: res.err,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return;
    } else if (res.success) {
      if (receipt === "true") {
        // setShowSuccessModal(true);
        setLoading(false);
        // setTimeout(() => {
        //   setShowSuccessModal(false);
        window.location.replace(`${process.env.NEXT_PUBLIC_APP_HOSTNAME}/${router.locale}/puja/registration/${data.CommunityEvent.urlExtension}/${data.CommunitySubEvent.urlExtension}/receipt?registrationID=${data.registrationID}`);
      } else {
        // if (registrationDetails?.type === "edit") {
        setErrorModal({
          open: true,
          heading: `${t("success")}`,
          message: res.message,
          acceptMethod: () => {
            setErrorModal({
              ...errorModal,
              open: false
            });
            router.push("/puja");
          },
          icon: <CheckCircleOutlineOutlinedIcon sx={{
            fontSize: "3rem",
            color: "green"
          }} />
        });
        setLoading(false);
        // dispatch(deleteRegistrationDetails());
        return;
      }
      // dispatch(deleteRegistrationDetails());

      //   // router.replace(
      //   //   `/${router.locale}/puja/registration/${eventid}/${subeventid}/success?registrationID=${registrationDetails.registrationID}`
      //   // );
      // }, 3000);
    } else if (!res.success) {
      if (receipt !== "true") {
        setErrorModal({
          open: true,
          heading: `${t("failed")}`,
          message: res.message,
          acceptMethod: () => {
            setErrorModal({
              ...errorModal,
              open: false
            });
            router.push("/puja");
          },
          icon: <ErrorOutlineOutlinedIcon sx={{
            fontSize: "3rem",
            color: "red"
          }} />
        });
        setLoading(false);
        // dispatch(deleteRegistrationDetails());
        return;
      }
    }
  };
  const handleAlterNo = value => {
    setTextError(prev => {
      return {
        ...prev,
        alternateNoError: false
      };
    });
    setAlterNoBtn(value);
    if (value === null) {
      setAlterNoVerifyModal(true);
    }
    if (value === false) {
      setAlterNoAdded(true);
      setAlternateNumber(primaryContact);
    }
  };
  const handlePrasad = value => {
    setTextError(prev => {
      return {
        ...prev,
        optPrasadError: false
      };
    });
    setIsPrasad(value);
    // setShowLinkedPrasadAlert(true);

    if (value === false && linkedBhetEventName.length > 0) {
      let bhetNames = linkedBhetEventName.join(", ");
      setPrasadOptedWarning({
        open: true,
        heading: t("prasad-not-opted"),
        message: `${t("you-have-added")} ${bhetNames} ${t("in-your-puja-by-selecting-no-for-delivery-you-understand-that-prasad-samagri-of-you-puja-will-not-be-sent-to-you")}`,
        acceptMethod: () => {
          setIsPrasad(true);
          setPrasadOptedWarning({
            ...errorModal,
            open: false
          });
        },
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />,
        positive: false
      });
    }
  };
  return <>
      {!bigScreen ? <>
          <Navbar activeStep={stepNo} setActiveStep={setStepNo} name={stepNo === 3 ? t("puja-details") : t("puja-wish")} />
          <Stack sx={{
        mt: "55px"
      }}>
            <RegistrationStepper activeStep={stepNo} bigScreen={false} />
            <PujaDetailsCard subEventDetails={subEventDetails}
        // show={false}
        />
            <div className={style.parentContainer}>
              {stepNo === 3 && <Box component={"form"} onSubmit={changeStep} noValidate>
                  <div className={classes.container}>
                    <div className={style.registrationDetails}>
                      {data?.alternateContact === null && !alterNoAdded ? <>
                          <Typography className={classes.registrationDetailsHeader}>
                            {t("confirm-whatsapp-number")}
                          </Typography>
                          <Typography sx={{
                    fontSize: "15px"
                  }}>
                            {t("is")}{" "}
                            <span className={style.alternateNo}>
                              {data.contact}{" "}
                            </span>
                            {t("your-whatsapp-number")}
                          </Typography>
                          <div className={style.toggleButton}>
                            <div className={`${style.btn} ${alterNoBtn != null && !alterNoBtn && style.btnYes}`} onClick={() => handleAlterNo(false)}>
                              {t("yes")}
                            </div>
                            <div className={`${style.btn} ${alterNoBtn != null && alterNoBtn && style.btnNo}`} onClick={() => handleAlterNo(null)}>
                              {t("no")}
                            </div>
                          </div>
                          {textError.alternateNoError && <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}>
                              <ErrorOutlineIcon sx={{
                      color: "#f44336",
                      fontSize: "12px"
                    }} />
                              <Typography sx={{
                      color: "#f44336",
                      fontSize: "12px"
                    }}>
                                {t("please-select-yes-or-no")}{" "}
                              </Typography>
                            </Box>}
                        </> : data?.alternateContact === null && alterNoAdded && <>
                            <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}>
                              <Typography className={classes.registrationDetailsHeader}>
                                {t("contact-details")}
                              </Typography>
                            </Box>
                            <Typography sx={{
                    fontSize: "15px",
                    color: theme.palette.primary.main
                  }}>
                              {t("puja-video-and-updates-will-be-sent-on-whatsapp")}
                            </Typography>

                            <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: "10px"
                  }}>
                              <Box sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px"
                    }}>
                                <CallIcon sx={{
                        color: "#1877F2",
                        fontSize: "18px"
                      }} />
                                <Typography>
                                  +91 {data?.contact.slice(-10)}
                                </Typography>
                              </Box>
                              <Image src={verifiedIcon} alt="verified" height={20} width={25} />
                            </Box>
                            <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: "5px"
                  }}>
                              <Box sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px"
                    }}>
                                <Image src={whatsappIcon} alt="whatsapp" height={20} width={20} />
                                {alterNoAdded ? <Typography>
                                    +91 {alternateNumber.slice(-10)}
                                  </Typography> : <Typography>
                                    +91{" "}
                                    {data?.User?.UserDetail?.alternateContact.slice(-10)}
                                  </Typography>}
                                <Image src={editIcon} alt="edit" height={18} width={20} onClick={() => {
                        setAlterNoVerifyModal(true);
                        setAlterNoAdded(false);
                      }} />
                              </Box>
                              <Box sx={{
                      display: "flex",
                      gap: "5px"
                    }}>
                                <Image src={verifiedIcon} alt="verified" height={20} width={25} />
                              </Box>
                            </Box>
                          </>}
                      {data.alternateContact === null && <Divider sx={{
                  opacity: "0.5",
                  m: "10px 0"
                }} />}

                      <Box sx={{
                  mb: "5px"
                }}>
                        <Typography className={classes.registrationDetailsHeader}>
                          {devoteeHeading}
                        </Typography>
                        <Typography sx={{
                    fontSize: "15px"
                  }}>
                          {t("puja-will-be-done-by-these-names-and-gotra")}{" "}
                        </Typography>
                        {maxOffering > 1 && <Typography sx={{
                    fontSize: "15px"
                  }}>
                            {t("add-upto")} {maxOffering} {t("members-0")}
                          </Typography>}
                      </Box>
                      {offeringNames.map((offering, index) => <div key={index}>
                          {index !== 0 ? <UtsavTextField type="text" name={"Offering Name"} value={offering} autoComplete="none" label={t("devotee-name")} setProps={handleChangeOfferingName} index={index} endAdornment={<RemoveCircleOutlineOutlinedIcon color="#6F7D83" sx={{
                    cursor: "pointer"
                  }} />} endAdornmentClick={deleteOfferingName} /> : <UtsavTextField type="text" name={"Offering Name"} value={offering} autoComplete="none" label={t("devotee-name")} setProps={handleChangeOfferingName} index={index} important={true} error={textError.offeringNameError} />}
                        </div>)}

                      {offeringNames.length < maxOffering && <div className={style.addWraps} onClick={addOfferingName}>
                          <div style={{
                    fontSize: "18px"
                  }}>+&nbsp;</div>{" "}
                          {t("add-name")}
                        </div>}

                      <UtsavTextField type="text" value={gotra} autoComplete="none" setProps={handleGotra} label={t("gotra")} endAdornment={<HtmlTooltip title={<>
                                <p>
                                  According to the 
                                  <a href="https://en.wikipedia.org/wiki/Saptarishi" target="_blank">
                                    <u style={{
                        color: "blue"
                      }}>Upanishad</u>
                                    s,
                                  </a>
                                  <em>
                                     Kashyapa, Atri, Vasistha, Vishvamitra,
                                    Gautama Maharishi, Jamadagni and
                                    Bharadvaja were seven sages (
                                    <a href="https://en.wikipedia.org/wiki/Saptarishi" target="_blank">
                                      <u style={{
                          color: "blue"
                        }}>
                                        saptarishi
                                      </u>
                                    </a>
                                    ) and Jambu Maharishi 
                                  </em>
                                  was another sage. The descendants of these
                                  eight sages are recognised to be gotras.
                                </p>
                                <p>
                                  Devotees who are unaware for their gotra or do
                                  not follow a gotra system should leave the
                                  gotra empty. As per pandits, such devotees are
                                  considered under Kashyap Gotra as Rishi
                                  Kashyap was one of the primary sages with the
                                  most number of followers
                                </p>
                                {/* <em>{"And here's"}</em> <b>{"some"}</b>{" "}
                                    <u>{"amazing content"}</u>.{" "}
                                    {"It's very engaging. Right?"} */}
                              </>} placement="top" open={openTooltip} onClose={handleClose} onOpen={handleOpen} disableFocusListener disableTouchListener>
                            <ErrorOutlineIcon sx={{
                    color: "#A9A9A9",
                    height: 20,
                    width: 20,
                    mt: "-2px",
                    cursor: "pointer"
                  }} />
                          </HtmlTooltip>} endAdornmentClick={handleOpen} />

                      {prasadAvailability && <>
                          {!isMainPrasad && <>
                              <Divider sx={{
                      opacity: "0.5",
                      m: "20px 0"
                    }} />
                              <Typography className={classes.registrationDetailsHeader}>
                                {t("do-you-want-to-receive-prasad-for-the-puja")}{" "}
                              </Typography>
                              {textError.optPrasadError && <Box sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px"
                    }}>
                                  <ErrorOutlineIcon sx={{
                        color: "#f44336",
                        fontSize: "12px"
                      }} />
                                  <Typography sx={{
                        color: "#f44336",
                        fontSize: "12px"
                      }}>
                                    {t("please-select-yes-or-no")}{" "}
                                  </Typography>
                                </Box>}
                              <div className={style.toggleButton}>
                                <div className={`${style.btn} ${isPrasad != null && isPrasad && style.btnYes}`} onClick={() => handlePrasad(true)}>
                                  {t("yes")}
                                </div>
                                <div className={`${style.btn} ${isPrasad != null && !isPrasad && style.btnNo}`} onClick={() => handlePrasad(false)}>
                                  {t("no")}
                                </div>
                              </div>
                            </>}
                          {(isPrasad || isMainPrasad) && <div className={style.addressDetailsContainer} ref={bigScreenRef}>
                              <Divider sx={{
                      opacity: "0.5",
                      m: "20px 0"
                    }} />

                              <Typography className={classes.registrationDetailsHeader}>
                                {t("prasad-delivery-address")}{" "}
                              </Typography>
                              <div className={style.addressDetails}>
                                <UtsavTextField type="number" name={"Pincode"} value={pincode} autoComplete="postal-code" setProps={handlePincode} label={t("pincode")} important={true} error={textError.pincodeError} />
                                {!isLoading ? <div className={style.locationIcon} onClick={e => {
                        if (isPrasad) {
                          e.preventDefault();
                          getLocation();
                        }
                      }}>
                                    <div style={{
                          color: !isPrasad ? "grey" : "orangered",
                          marginTop: "5px"
                        }}>
                                      <LocationOnIcon />{" "}
                                    </div>
                                    <Typography style={{
                          color: !isPrasad ? "grey" : "orangered"
                        }}>
                                      {" "}
                                      {t("current-location")}
                                    </Typography>
                                  </div> : <Box sx={{
                        display: "flex",
                        gap: "4px",
                        alignItems: "center"
                      }}>
                                    <CircularProgress size={18} sx={{
                          color: "#ff9800"
                        }} />
                                    <Typography>
                                      Fetching location...
                                    </Typography>
                                  </Box>}
                              </div>
                              <div className={style.addressDetails}>
                                <UtsavTextField type="text" name={"City"} value={city} setProps={handleCityChange} label={t("city-district")} important={true} error={textError.cityError} />
                                <FormControl fullWidth sx={{
                        mt: 1
                      }}>
                                  <InputLabel id="demo-simple-select-label" sx={{
                          color: "#6F7D83 !important"
                        }} error={textError.stateError} required={true}>
                                    {t("state")}
                                  </InputLabel>
                                  <Select labelId="demo-simple-select-label" id="demo-simple-select" name="State" value={state} label="State" onChange={e => handleStateChange(e.target.value)}>
                                    {states.map((state, index) => <MenuItem key={index} value={state.name}>
                                        {state.name}
                                      </MenuItem>)}
                                  </Select>
                                </FormControl>
                              </div>
                              <UtsavTextField type="text" name={"Floor/House No./Building Name"} value={buildingName} setProps={handleBuildingName} label={t("floor-house-no-building-name")} important={true} error={textError.buildingNameError} />
                              <UtsavTextField type="text" value={roadName} autoComplete="address" name={"Road Name"} setProps={handleRoadName} label={t("road-name-area-colony")} multiline={true} rows={4} important={true} error={textError.roadNameError} />
                            </div>}
                        </>}
                    </div>
                  </div>
                  <div className={classes.bottomContainer}>
                    <SubmitBtn btnText={`${t("Next")}`} loading={loading} postionFixed={true} setProps={trackEventFunction} disabled={isLoading} />
                  </div>
                </Box>}

              {stepNo === 4 && <Box component={"form"} onSubmit={updateAddress} noValidate>
                  <div className={classes.container}>
                    <Typography className={classes.registrationDetailsHeader}>
                      {t("write-your-wish-for-the-puja-manokamna")}{" "}
                    </Typography>
                    <Box sx={{
                mt: -2
              }}>
                      <UtsavTextField autoComplete="notes" setProps={handleNotes} value={notes} label={t("wish-for-the-puja")} multiline={true} rows={4} />
                    </Box>
                  </div>
                  <div className={classes.bottomContainer}>
                    <SubmitBtn btnText={`${t("done")}`} loading={loading} setProps={trackEventFunction} />
                  </div>
                </Box>}
              {/* {isLoading && <LoadingCircle />} */}
            </div>
          </Stack>
        </> : <>
          <NavbarBigScreen activeStep={stepNo} showDivider={false} />
          <div className={classes.bigScreenContainer}>
            <div className={classes.containerLHS}>
              <div className={classes.containerLHSInner}>
                <Box component={"form"} className={`${style.parentContainer} ${stepNo === 4 && style.hideParentContainer}`} onSubmit={changeStep} noValidate>
                  {stepNo === 3 && <Stack justifyContent={"space-between"}>
                      <div className={classes.container}>
                        <div className={style.registrationDetails}>
                          {data.alternateContact === null && !alterNoAdded ? <>
                              <Typography className={classes.registrationDetailsHeader}>
                                {t("confirm-whatsapp-number")}
                              </Typography>
                              <Typography sx={{
                        fontSize: "15px"
                      }}>
                                {t("is")}{" "}
                                <span className={style.alternateNo}>
                                  {data.contact}{" "}
                                </span>
                                {t("your-whatsapp-number")}
                              </Typography>
                              <div className={style.toggleButton}>
                                <div className={`${style.btn} ${alterNoBtn != null && !alterNoBtn && style.btnYes}`} onClick={() => handleAlterNo(false)}>
                                  {t("yes")}
                                </div>
                                <div className={`${style.btn} ${alterNoBtn != null && alterNoBtn && style.btnNo}`} onClick={() => handleAlterNo(null)}>
                                  {t("no")}
                                </div>
                              </div>
                              {textError.alternateNoError && <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px"
                      }}>
                                  <ErrorOutlineIcon sx={{
                          color: "#f44336",
                          fontSize: "12px"
                        }} />
                                  <Typography sx={{
                          color: "#f44336",
                          fontSize: "12px"
                        }}>
                                    {t("please-select-yes-or-no")}{" "}
                                  </Typography>
                                </Box>}
                            </> : data.alternateContact === null && alterNoAdded && <>
                                <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                      }}>
                                  <Typography className={classes.registrationDetailsHeader}>
                                    {t("contact-details")}
                                  </Typography>

                                  <Image src={editIcon} alt="edit" height={18} width={20} onClick={() => {
                          setAlterNoVerifyModal(true);
                          setAlterNoAdded(false);
                        }} />
                                </Box>
                                <Typography sx={{
                        fontSize: "15px",
                        color: theme.palette.primary.main
                      }}>
                                  {t("puja-video-and-updates-will-be-sent-on-whatsapp")}
                                </Typography>

                                <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: "10px"
                      }}>
                                  <Box sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px"
                        }}>
                                    <CallIcon sx={{
                            color: "#1877F2",
                            fontSize: "18px"
                          }} />
                                    <Typography>
                                      +91 {data?.contact.slice(-10)}
                                    </Typography>
                                  </Box>
                                  <Image src={verifiedIcon} alt="verified" height={20} width={25} />
                                </Box>
                                <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: "5px"
                      }}>
                                  <Box sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px"
                        }}>
                                    <Image src={whatsappIcon} alt="whatsapp" height={20} width={20} />
                                    {alterNoAdded ? <Typography>
                                        +91 {alternateNumber.slice(-10)}
                                      </Typography> : <Typography>
                                        +91{" "}
                                        {data?.User?.UserDetail?.alternateContact.slice(-10)}
                                      </Typography>}
                                  </Box>
                                  <Image src={verifiedIcon} alt="verified" height={20} width={25} />
                                </Box>
                              </>}
                          {data.alternateContact === null && <Divider sx={{
                      opacity: "0.5",
                      m: "10px 0"
                    }} />}
                          <Box sx={{
                      mb: "5px"
                    }}>
                            <Typography className={classes.registrationDetailsHeader}>
                              {devoteeHeading}
                            </Typography>
                            <Typography sx={{
                        fontSize: "14px"
                      }}>
                              {t("puja-will-be-done-by-these-names-and-gotra")}
                            </Typography>
                            {maxOffering > 1 && <Typography sx={{
                        fontSize: "14px"
                      }}>
                                {t("add-upto")} {maxOffering} {t("members-0")}
                              </Typography>}
                          </Box>
                          {offeringNames.map((offering, index) => <div key={index}>
                              {index !== 0 ? <UtsavTextField type="text" value={offering} autoComplete="none" label={t("devotee-name")} setProps={handleChangeOfferingName} index={index} endAdornment={<RemoveCircleOutlineOutlinedIcon color="#6F7D83" sx={{
                        cursor: "pointer"
                      }} />} endAdornmentClick={deleteOfferingName} /> : <UtsavTextField type="text" value={offering} autoComplete="none" label={t("devotee-name")} setProps={handleChangeOfferingName} index={index} important={true} error={textError.offeringNameError} />}
                            </div>)}

                          {offeringNames.length < maxOffering && <div className={style.addWraps} onClick={addOfferingName}>
                              <div style={{
                        fontSize: "18px"
                      }}>+&nbsp;</div>{" "}
                              {t("add-name")}
                            </div>}

                          <UtsavTextField type="text" value={gotra} autoComplete="none" setProps={handleGotra} label={t("gotra")} endAdornment={<HtmlTooltip title={<>
                                    {/* <Typography color="inherit">
                                      Tooltip with HTML
                                     </Typography> */}
                                    <p>
                                      According to the 
                                      <a href="https://en.wikipedia.org/wiki/Saptarishi" target="_blank">
                                        <u style={{
                            color: "blue"
                          }}>
                                          Upanishad
                                        </u>
                                        s,
                                      </a>
                                      <em>
                                         Kashyapa, Atri, Vasistha, Vishvamitra,
                                        Gautama Maharishi, Jamadagni and
                                        Bharadvaja were seven sages (
                                        <a href="https://en.wikipedia.org/wiki/Saptarishi" target="_blank">
                                          <u style={{
                              color: "blue"
                            }}>
                                            saptarishi
                                          </u>
                                        </a>
                                        ) and Jambu Maharishi 
                                      </em>
                                      was another sage. The descendants of these
                                      eight sages are recognised to be gotras.
                                    </p>
                                    <p>
                                      Devotees who are unaware for their gotra
                                      or do not follow a gotra system should
                                      leave the gotra empty. As per pandits,
                                      such devotees are considered under Kashyap
                                      Gotra as Rishi Kashyap was one of the
                                      primary sages with the most number of
                                      followers
                                    </p>
                                    {/* <em>{"And here's"}</em> <b>{"some"}</b>{" "}
                                     <u>{"amazing content"}</u>.{" "}
                                     {"It's very engaging. Right?"} */}
                                  </>} placement="top" open={openTooltip} onClose={handleClose} onOpen={handleOpen} disableFocusListener disableTouchListener>
                                <ErrorOutlineIcon sx={{
                        color: "#A9A9A9",
                        height: 20,
                        width: 20,
                        mt: "-2px",
                        cursor: "pointer"
                      }} />
                              </HtmlTooltip>} endAdornmentClick={handleOpen} />
                          <Divider sx={{
                      opacity: "0.5",
                      m: "20px 0"
                    }} />

                          {prasadAvailability && <>
                              {!isMainPrasad && <>
                                  <Typography className={classes.registrationDetailsHeader}>
                                    {t("do-you-want-to-receive-prasad-for-the-puja")}{" "}
                                  </Typography>
                                  {textError.optPrasadError && <Box sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px"
                        }}>
                                      <ErrorOutlineIcon sx={{
                            color: "#f44336",
                            fontSize: "12px"
                          }} />
                                      <Typography sx={{
                            color: "#f44336",
                            fontSize: "12px"
                          }}>
                                        {t("please-select-yes-or-no")}{" "}
                                      </Typography>
                                    </Box>}
                                  <div className={style.toggleButton}>
                                    <div className={`${style.btn} ${isPrasad != null && isPrasad && style.btnYes}`} onClick={() => handlePrasad(true)}>
                                      {t("yes")}
                                    </div>
                                    <div className={`${style.btn} ${isPrasad != null && !isPrasad && style.btnNo}`} onClick={() => handlePrasad(false)}>
                                      {t("no")}
                                    </div>
                                  </div>
                                </>}
                            </>}
                        </div>
                      </div>
                      {!isPrasad && <div className={classes.bottomContainer}>
                          <SubmitBtn btnText={"Next"} loading={loading} setProps={trackEventFunction} />
                        </div>}
                    </Stack>}
                  {stepNo === 3 && (isPrasad || isMainPrasad) && <>
                      <Stack justifyContent={"space-between"} ref={bigScreenRef}>
                        <div className={classes.container}>
                          <div className={style.addressDetailsContainer}>
                            <Box sx={{
                        mb: "5px"
                      }}>
                              <Typography className={classes.registrationDetailsHeader}>
                                {t("prasad-delivery-address")}{" "}
                              </Typography>
                              <Typography sx={{
                          fontSize: "14px"
                        }}>
                                {t("prasad-after-puja-will-be-delivered-to-this-address")}
                              </Typography>
                            </Box>
                            <div className={style.addressDetails}>
                              <UtsavTextField type="number" name={"Pincode"} value={pincode} autoComplete="postal-code" setProps={handlePincode} label={t("pincode")} important={true} error={textError.pincodeError} />
                              {!isLoading ? <div className={style.locationIcon} onClick={e => {
                          if (isPrasad) {
                            e.preventDefault();
                            getLocation();
                          }
                        }}>
                                  <div style={{
                            color: !isPrasad ? "grey" : "orangered",
                            marginTop: "5px"
                          }}>
                                    <LocationOnIcon />{" "}
                                  </div>
                                  <Typography style={{
                            color: !isPrasad ? "grey" : "orangered"
                          }}>
                                    {" "}
                                    {t("current-location")}
                                  </Typography>
                                </div> : <Box sx={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center"
                        }}>
                                  <CircularProgress size={18} sx={{
                            color: "#ff9800"
                          }} />
                                  <Typography>Fetching location...</Typography>
                                </Box>}
                            </div>
                            <div className={style.addressDetails}>
                              <UtsavTextField type="text" name={"City"} value={city} setProps={handleCityChange} label={t("city-district")} important={true} error={textError.cityError} />
                              <FormControl fullWidth sx={{
                          mt: 1
                        }}>
                                <InputLabel id="demo-simple-select-label" sx={{
                            color: "#6F7D83 !important"
                          }} name="State" error={textError.stateError} required={true}>
                                  {t("state")}
                                </InputLabel>
                                <Select labelId="demo-simple-select-label" id="demo-simple-select" value={state} label="State" onChange={e => handleStateChange(e.target.value)}>
                                  {states.map((state, index) => <MenuItem key={index} value={state.name}>
                                      {state.name}
                                    </MenuItem>)}
                                </Select>
                              </FormControl>
                            </div>
                            <UtsavTextField type="text" name={"Floor/House No./Building Name"} value={buildingName} setProps={handleBuildingName} label={t("floor-house-no-building-name")} important={true} error={textError.buildingNameError} />

                            <UtsavTextField type="text" name={"Road Name"} value={roadName} autoComplete="address" setProps={handleRoadName} label={t("road-name-area-colony")} multiline={true} rows={4} important={true} error={textError.roadNameError} />
                          </div>
                        </div>
                        <div className={classes.bottomContainer}>
                          <SubmitBtn btnText={`${t("Next")}`} loading={loading} setProps={trackEventFunction} disabled={isLoading} />
                        </div>
                      </Stack>
                    </>}
                </Box>
                <Box sx={{
              display: "flex",
              height: "100%"
            }} component={"form"} onSubmit={updateAddress} noValidate>
                  {stepNo === 4 && <Stack height={"500px"} justifyContent={"flex-start"}>
                      <div className={style.backContainer} onClick={() => {
                  setStepNo(3);
                }}>
                        <ArrowBackIosNewIcon sx={{
                    fontSize: "16px"
                  }} />
                        <Typography fontWeight={"bold"} sx={{
                    ml: "5px"
                  }}>
                          Back
                        </Typography>
                      </div>
                      <div className={classes.container}>
                        <Typography className={classes.registrationDetailsHeader}>
                          {t("write-your-wish-for-the-puja-manokamna")}{" "}
                        </Typography>
                        <Box sx={{
                    mt: -2
                  }}>
                          <UtsavTextField autoComplete="notes" setProps={handleNotes} value={notes} label={t("wish-for-the-puja")} multiline={true} rows={4} />
                        </Box>
                      </div>
                      <div className={classes.bottomContainer}>
                        <SubmitBtn btnText={`${t("done")}`} loading={loading} setProps={trackEventFunction} />
                      </div>
                    </Stack>}
                  {isLoading && <LoadingCircle />}
                </Box>
              </div>
            </div>

            <Box>
              <PujaDetailsCard subEventDetails={subEventDetails}
          // show={true}
          // receipt={true}
          />
            </Box>
          </div>
        </>}

      {verificationModal && <VerificationModal open={verificationModal} setOpen={setVerificationModal} setErrorModal={setErrorModal} errorModal={errorModal} contact={primaryContact} setContact={setPrimaryContact} />}

      {alterNoVerifyModal && <AlternateNoVerificationModal open={alterNoVerifyModal} setOpen={setAlterNoVerifyModal} alternateNumber={alternateNumber} setAlternateNumber={setAlternateNumber} setAlterNoBtn={setAlterNoBtn} setErrorModal={setErrorModal} errorModal={errorModal} setAlterNoAdded={setAlterNoAdded} />}

      {errorModal.open && <UtsavNewModal open={errorModal.open} heading={errorModal.heading} message={errorModal.message} acceptMsg={t("okay")} onAccept={errorModal.acceptMethod} icon={errorModal.icon} />}

      {prasadOptedWarning.open && <UtsavNewModal open={prasadOptedWarning.open} toggleModal={() => setPrasadOptedWarning(prevState => ({
      ...prevState,
      open: false
    }))} heading={prasadOptedWarning.heading} message={prasadOptedWarning.message} acceptMsg={t("send-prasad")} onAccept={prasadOptedWarning.acceptMethod} rejectMsg={t("dont-send")} icon={prasadOptedWarning.icon} positive={prasadOptedWarning.positive} />}
    </>;
}
export default RegistrationDetails;